module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/Footer/images/button_bg.de545059.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/Footer/images/button_bg.png
// module id = 3452
// module chunks = 11